<div class="sidebar-header">{{headerContent}}</div>
<form class="standard-form" (ngSubmit)="onSubmit()" [formGroup]="priorityForm">
  <label class="standard-label" for="priorityDescription">Priority Statement</label>
  <div class="input-error-wrap sans-margin">
    <textarea auto="description-field" pInputTextarea class="text-area" id="priorityDescription"
              name="priority description" placeholder="Enter Priority Statement here"
              [formControl]="description" [maxlength]="MAX_DESCRIPTION_LENGTH">
    </textarea>
    <div class="remaining-msg">Remaining: {{descriptionRemainingCharacters}}</div>
    <app-error-msg [control]="description" [show]="description.invalid && description.touched && description.dirty">
    </app-error-msg>
  </div>

  <label class="standard-label" for="priorityTitle">Strategic Theme</label>
  <div class="input-error-wrap sans-margin">
    <input auto="strategic-theme-field" class="standard-input block" type="text" id="priorityTitle"
           placeholder="Enter Strategic Theme here" name="priority title"
           [formControl]="title" [maxlength]="MAX_TITLE_LENGTH">
    <div class="remaining-msg">Remaining: {{titleRemainingCharacters}}</div>
    <app-error-msg [control]="title" [show]="title.invalid && title.touched && title.dirty"></app-error-msg>
  </div>
  <label class="standard-label" for="priorityTag">Select a Tag</label>
  <div class="input-error-wrap sans-margin">
    <p-dropdown auto="tag-drop" class="standard-input block" id="priorityTag" name="priority tag" [autoWidth]="false"
                [options]="tagSelectItems" [formControl]="tag">
    </p-dropdown>
    <app-error-msg [control]="tag" [show]="tag.invalid && tag.touched && tag.dirty"></app-error-msg>
  </div>
  <div class="button-row">
    <button auto="cancel-btn" class="btn btn-alt left-btn" type="button" (click)="cancel.emit()">Cancel</button>
    <button auto="save-btn" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
</form>
